import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-loop')
export class ObiLoop extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M4 12C4 10.3548 5.35378 9 7.05 9C8.00869 9 8.86437 9.52567 9.57834 10.251L10.6131 8.47755C9.72075 7.68616 8.52518 7 7.05 7C4.27271 7 2 9.2269 2 12C2 14.7731 4.27271 17 7.05 17C9.06142 17 10.553 15.7243 11.465 14.6456C11.6636 14.4107 11.842 14.1766 12 13.9537L13.1266 12C13.1482 11.9618 13.1712 11.9215 13.1959 11.8793C13.2028 11.8674 13.2099 11.8554 13.2171 11.8432L13.2827 11.7294L13.2847 11.7304C13.4779 11.4135 13.7393 11.0277 14.0624 10.6456C14.8413 9.72431 15.8247 9 16.95 9C18.6462 9 20 10.3548 20 12C20 13.6452 18.6462 15 16.95 15C15.9928 15 15.1382 14.4759 14.4249 13.7523L13.3983 15.5325C14.2894 16.3197 15.4811 17 16.95 17C19.7273 17 22 14.7731 22 12C22 9.2269 19.7273 7 16.95 7C14.9386 7 13.447 8.27569 12.535 9.35439C12.3659 9.55451 12.2113 9.75398 12.0716 9.94646L10.8734 12C10.8733 12.0001 10.8734 11.9999 10.8734 12C10.8519 12.0381 10.8287 12.0786 10.8041 12.1207C10.6055 12.4609 10.3132 12.9101 9.93761 13.3544C9.15874 14.2757 8.17533 15 7.05 15C5.35378 15 4 13.6452 4 12Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 12C4 10.3548 5.35378 9 7.05 9C8.00869 9 8.86437 9.52567 9.57834 10.251L10.6131 8.47755C9.72075 7.68616 8.52518 7 7.05 7C4.27271 7 2 9.2269 2 12C2 14.7731 4.27271 17 7.05 17C9.06142 17 10.553 15.7243 11.465 14.6456C11.6636 14.4107 11.842 14.1766 12 13.9537L13.1266 12C13.1482 11.9618 13.1712 11.9215 13.1959 11.8793C13.2028 11.8674 13.2099 11.8554 13.2171 11.8432L13.2827 11.7294L13.2847 11.7304C13.4779 11.4135 13.7393 11.0277 14.0624 10.6456C14.8413 9.72431 15.8247 9 16.95 9C18.6462 9 20 10.3548 20 12C20 13.6452 18.6462 15 16.95 15C15.9928 15 15.1382 14.4759 14.4249 13.7523L13.3983 15.5325C14.2894 16.3197 15.4811 17 16.95 17C19.7273 17 22 14.7731 22 12C22 9.2269 19.7273 7 16.95 7C14.9386 7 13.447 8.27569 12.535 9.35439C12.3659 9.55451 12.2113 9.75398 12.0716 9.94646L10.8734 12C10.8733 12.0001 10.8734 11.9999 10.8734 12C10.8519 12.0381 10.8287 12.0786 10.8041 12.1207C10.6055 12.4609 10.3132 12.9101 9.93761 13.3544C9.15874 14.2757 8.17533 15 7.05 15C5.35378 15 4 13.6452 4 12Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-loop': ObiLoop;
  }
}
